"use strict";

var _themeSections = require("@shopify/theme-sections");

var _carousel = _interopRequireDefault(require("../components/carousel"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Section: Image slider
 * ------------------------------------------------------------------------------
 * Large component displaying image galleries in a carousel.
 *
 * @namespace imageSlider
 */

/**
 * DOM selectors.
 */


var selectors = {
  container: '[js-image-slider="container"]',
  cell: '[js-image-slider="cell"]'
};
/**
 * Global vars.
 */

var imageSlider = {};
/**
 * Image slider section constructor.
 * Executes on page load as well as Theme Editor `section:load` events.
 * @param {string} container - Selector for the section container DOM element.
 */

(0, _themeSections.register)('image-slider', {
  /**
   * Cache selectors.
   * - Define necessary variables and make available for component use.
   */
  cacheSelectors: function cacheSelectors() {
    var sectionContainer = "[data-section-id=\"".concat(this.id, "\"]");
    var container = "".concat(sectionContainer, " ").concat(selectors.container);
    var cells = "".concat(sectionContainer, " ").concat(selectors.cell);
    this.cache = {
      sectionContainer: sectionContainer,
      container: container,
      cells: cells
    };
  },

  /**
   * Check if the section has enabled the slider option.
   */
  isSliderEnabled: function isSliderEnabled() {
    return document.querySelector(this.cache.container) !== null;
  },

  /**
   * Construct carousel using imported Carousel component.
   */
  constructCarousel: function constructCarousel() {
    var autoPlayValue = document.querySelector(this.cache.sectionContainer).getAttribute('data-autoplay');
    var autoPlayNumber = parseInt(autoPlayValue, 10);
    imageSlider = new _carousel["default"](this.cache.container, {
      autoPlay: autoPlayNumber,
      cellSelector: this.cache.cells,
      pageDots: false,
      prevNextButtons: true,
      freeScroll: true,
      freeScrollFriction: 0.1
    });
    imageSlider.init();
  },

  /**
   * Construct section events
   */
  onLoad: function onLoad() {
    this.cacheSelectors();

    if (this.isSliderEnabled()) {
      this.constructCarousel();
    }
  },

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload: function onUnload() {
    imageSlider.reload();
  },

  /**
   * Event callback for Theme Editor `section:select` event
   */
  onSelect: function onSelect() {
    imageSlider.resize();
  }
});